import type { SVGProps } from "react";
// generated from BookOpened.svg — do not edit manually
// prettier-ignore
export default function BookOpened(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12 20 H 2 V 4 H 8 C 10.209 4 12 5.791 12 8 M 12 20 H 22 V 4 H 16 C 13.791 4 12 5.791 12 8 M 12 20 V 8" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
